import React from 'react'
import PropType from 'prop-types'
import { v4 as uuid } from 'uuid';
import Menu from '@material-ui/core/Menu'
import Paper from '../Paper'

const MenuAdapter = ({ className, items, type }) => {
  switch (type) {
    case 'dynamic': return (
      <Menu>
        { items.map(
          (item) => (<React.Fragment key={uuid()}>{item}</React.Fragment>),
        )}
      </Menu>
    )
    case 'popover':
    case 'default':
    default: return (
      <Paper className={className}>
        { items.map((item) => (<React.Fragment key={uuid()}>{item}</React.Fragment>)) }
      </Paper>
    )
  }
}

MenuAdapter.defaultProps = {
  className: '',
  type: 'static',
}

MenuAdapter.propTypes = {
  className: PropType.string,
  items: PropType.arrayOf(PropType.node).isRequired,
  type: PropType.oneOf(['static', 'dynamic', 'popover']),
}

export default MenuAdapter
